import { sample } from 'lodash'

const adjectives = [
  'bouncy',
  'curious',
  'cheerful',
  'sparkly',
  'wobbly',
  'zigzag',
  'peppy',
  'snazzy',
  'zippy',
  'quirky',
  'chatty',
  'sneaky',
  'goofy',
  'spicy',
  'sunny',
  'breezy',
  'cosmic',
  'dizzy',
  'jazzy',
  'loopy',
  'peachy',
  'perky',
  'plucky',
  'sassy',
  'silly',
  'snug',
  'spunky',
  'witty',
  'wonky',
  'zesty',
  'gentle',
  'bright',
  'caffeinated',
  'pixelated',
  'galactic',
  'whimsical',
  'glowing',
  'playful',
]

const people = [
  'developer',
  'analyst',
  'researcher',
  'engineer',
  'scientist',
  'architect',
  'tester',
  'hacker',
  'astronaut',
  'pilot',
  'navigator',
  'cartographer',
  'biologist',
  'roboticist',
  'designer',
  'strategist',
  'programmer',
  'librarian',
  'alchemist',
  'wizard',
]

const companies = [
  'qubyte',
  'rubberducklabs',
  'cosmicode',
  'nebulatech',
  'starlightly',
  'bugmuncher',
  'bitbiscuit',
  'zippycloud',
  'snazzystack',
  'marshmallowx',
  'latencyllama',
  'galaxibit',
  'pixelpajama',
  'quasarshift',
  'whimsyware',
  'croniverse',
  'toastify',
  'packetpony',
  'widgetworks',
  'fuzzybyte',
]

export const generateSlug = (): string => {
  const adjective = sample(adjectives) ?? 'quirky'
  const person = sample(people) ?? 'developer'
  const company = sample(companies) ?? 'rubberducklabs'

  return `${adjective}-${person}@${company}.com`
}

